import { render } from "./FormularioSearchParams.vue?vue&type=template&id=6ea29c10"
import script from "./FormularioSearchParams.vue?vue&type=script&lang=ts"
export * from "./FormularioSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script